import { Color } from "three"
import type { Nullable } from "../../../../typescript"
import type { Entity } from "../../../core/entity/index"
import type { NeighborWeights } from "./NeighborWeights.type"
import type { NeighborColors } from "./calculateNodeVertexOutputColor"

/**
 * Calculates the weighted average color for a tile position based on weights.
 * 
 * @param weights - Weights computed from a normalized (x, y) point
 * @param colors - Colors for the base and neighbors
 * @param out - Optional output Color to avoid allocations
 * @returns the interpolated color
 */
export default function calculateShoalNodeVertexOutputColor(
  weights: NeighborWeights,
  colors: NeighborColors,
  eightNeighborSameTypeList: Array<Nullable<Entity>>,
  out: Color = new Color(),
): Color {
  const { base: wBase, list: wList, total } = weights
  const { list: cList } = colors

  let r = wBase * out.r
  let g = wBase * out.g
  let b = wBase * out.b

  let c: Color

  for (let i = 0; i < 8; i++) {
    const w = wList[i]
    if (i % 2 === 0 && eightNeighborSameTypeList[i]) {
      // if a non-diagonal neighbor is a shoal, use the special shoal color
      c = out
    } else if (eightNeighborSameTypeList[i] && eightNeighborSameTypeList[(i + 9) % 8] && eightNeighborSameTypeList[(i + 7) % 8]) {
      c = out
    } else {
      // otherwise use the neighbor's AVG pre-blended color
      c = cList[i]
    }
    r += w * c.r
    g += w * c.g
    b += w * c.b
  }

  const d = total > 0 ? total : 1
  return out.setRGB(r / d, g / d, b / d)
}
